import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from 'axios';
import $ from 'jquery';
import * as localForage from 'localforage';

function Location(city, state, country, country_en, state_en, city_en) {
    this.counter = 0;
    this.country_en = country_en;
    this.state_en = state_en;
    this.city_en = city_en;
    this.country = country;
    this.city = city;
    this.state = state;
    if (this.state_en == '' && this.city_en != '') {
        this.state_en = this.city_en;
    }
    this.id = (city + 'cx' + state + 'jj' + country).toLowerCase().replace(/[\s]+/g, '');
    this.display = function () {
        var toReturn = this.country;
        if (this.state) {
            toReturn = this.state + ', ' + toReturn;
        }
        if (this.city) {
            toReturn = this.city + ', ' + toReturn;
        }
        return toReturn;
    };

    this.sortingWeight = function () {
        var weight = Math.ceil(1 / this.counter * 100);
        if (this.city || this.state) {
            weight += 1000;
        }
        return weight;
    };
}

function sortLocationsObject(locations) {
    var sortedLocations = [];
    for (var i in locations) {
        var location = locations[i];
        var countryName = global.getCountryByCode(location.country);
        var newObj = new Location(location.city, location.state, countryName, location.country_en, location.state_en, location.city_en);
        newObj.counter = location.counter;
        sortedLocations.push(newObj);
    }
    sortedLocations.sort(function (a, b) {
        if (a.sortingWeight() > b.sortingWeight()) {
            return -1;
        } else if (a.sortingWeight() < b.sortingWeight()) {
            return 1;
        }
        return 0;
    });
    return sortedLocations;
}

export default {
    data: function data() {
        return {
            results: [],
            loading: false,
            globalSortedLocations: [],
            selectedLocationFilter: null,
            lastSearchType: '',
            availableSearchBalance: -1
        };
    },
    created: function created() {
        var searchHelper = new global.SearchHelper(this.$route.params.search);
        searchHelper.setLastSearchMeta();

        this.globalLocations = sortLocationsObject(this.globalLocations);
        if (process.client) {
            //this.lastSearchType = sessionStorage.getItem('lastSearchType');
            this.lastSearchType = customSessionStorage.getItem('lastSearchType');
            this.$auth.getUser(function (user) {
                if (user) {
                    this.availableSearchBalance = user.available_search_credits;
                }
            }.bind(this));
        }
    },
    mounted: function mounted() {
        var body = document.body; // Safari
        var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
        body.scrollTop = 0;
        html.scrollTop = 0;
    },
    asyncData: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                route = _ref.route;

            var searchText, vaildPersonsCount, globalLocations, searchHelper, searchTags, filterIcon, params, _ref3, data, processedData, i, newAddressedPersonFlag, j, address, tmpLocation, _i, uniqueLocationsArray, _j;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            searchText = route.params.search.replace('-', ' ');
                            vaildPersonsCount = 0;
                            globalLocations = {};
                            searchHelper = new global.SearchHelper(searchText);

                            searchHelper.searchRequestParams.from_page = 'results';
                            searchTags = searchHelper.searchTags;
                            filterIcon = searchHelper.filterIcon;
                            params = searchHelper.searchRequestParams;

                            /*
                            let params = {};
                            let type='';            
                            if(searchText.match(/@/) )
                                type = 'email';
                            else if(searchText.match(/^[0-9\(\) \+\-]+$/g) )
                                type =  'phone';
                            else 
                                type =  'name';    
                            
                            switch (type) {
                                case 'email':
                                    params = {email: route.params.search,lang: route.params.lang};
                                    searchTags.push(route.params.search);
                                    filterIcon = 'fa fa-envelope';
                                    break;
                                     case 'phone':
                                    params = {phone: route.params.search,lang: route.params.lang};
                                    searchTags.push(route.params.search);
                                    filterIcon = 'fa fa-phone';
                                    break;
                                default:
                                    params = {raw_name: route.params.search,lang: route.params.lang};
                                    searchTags.push(route.params.search);
                                    filterIcon = 'fa fa-user';
                                 }
                            */

                            params.country = route.params.country;
                            params.state = route.params.state;
                            params.city = route.params.city;
                            _context.next = 13;
                            return axios.get(global.getEndPoint() + 'api/search-process', {
                                params: params
                            });

                        case 13:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            processedData = data.persons;

                            for (i in processedData) {
                                // search filter classes
                                processedData[i].filterClasses = [];

                                if (processedData[i].names && processedData[i].names.length) {
                                    vaildPersonsCount++;
                                }
                                processedData[i].uniqueLocations = {};
                                newAddressedPersonFlag = {};

                                for (j in processedData[i].addresses) {
                                    address = processedData[i].addresses[j];

                                    if (typeof processedData[i].uniqueLocations[address.city + '-' + address.state + '-' + address.country] == 'undefined') {
                                        processedData[i].uniqueLocations[address.city + '-' + address.state + '-' + address.country] = address;
                                    }

                                    if (processedData[i].names && processedData[i].names.length) {

                                        // set global locations
                                        tmpLocation = new Location(address.city, address.state, global.getCountryByCode(address.country), address.country_en, address.state_en, address.city_en);
                                        /*tmpLocation.country_en=address.country_en;
                                        tmpLocation.city_en=address.city_en;
                                        tmpLocation.state_en=address.state_en;*/

                                        if (typeof globalLocations[tmpLocation.id] == 'undefined') {
                                            globalLocations[tmpLocation.id] = tmpLocation;
                                        }
                                        if (typeof newAddressedPersonFlag[tmpLocation.id] == 'undefined') {
                                            globalLocations[tmpLocation.id].counter++;
                                            newAddressedPersonFlag[tmpLocation.id] = true;
                                        }
                                        // filter classes
                                        processedData[i].filterClasses.push(tmpLocation.id);
                                    }
                                }
                            }

                            for (_i in processedData) {
                                uniqueLocationsArray = [];

                                for (_j in processedData[_i].uniqueLocations) {
                                    uniqueLocationsArray.push(processedData[_i].uniqueLocations[_j]);
                                }
                                processedData[_i].uniqueLocations = uniqueLocationsArray;
                            }

                            return _context.abrupt('return', {
                                results: processedData,
                                searchText: searchText,
                                searchTags: searchTags,
                                vaildPersonsCount: vaildPersonsCount,
                                filterIcon: filterIcon,
                                globalLocations: sortLocationsObject(globalLocations)
                            });

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function asyncData(_x) {
            return _ref2.apply(this, arguments);
        }

        return asyncData;
    }(),
    head: function head() {
        return {
            titleTemplate: this.getTitle(),
            meta: [{ hid: 'description', name: 'description', content: this.getDescription() }, { hid: 'keywords', name: 'keywords', content: this.getKeywords() }, { hid: 'og:description', name: 'og:description', content: this.getDescription() }, { hid: 'og:title', name: 'og:title', content: this.getTitle() }]
        };
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    methods: {
        getTitle: function getTitle() {
            return this.$root._route.params.search.replace(new RegExp('-', 'g'), ' ') + ' ' + this.$root.trans('st_public.phone_number_email_address', this.$root._route.params.lang, { website: this.$root.trans(global.websiteSettings.extra_info.title) }) + ' - ' + this.$root.trans(global.websiteSettings.extra_info.title, this.$root._route.params.lang);
        },
        getDescription: function getDescription() {
            return this.$root.trans('st_public.find_phone_number_email_address', { website: this.$root.trans(global.websiteSettings.extra_info.title),
                name: this.$root._route.params.search.replace(new RegExp(' ', 'g'), '-'),
                results: this.results.length });
        },
        getKeywords: function getKeywords() {
            return this.$root.trans('st_public.keywords_meta_tags', { name: this.$root._route.params.search.replace(new RegExp(' ', 'g'), '-') });
        },
        ResultAddressLink: function ResultAddressLink(location) {
            var url = '/' + this.lang + '/' + this.$root._route.params.search;
            if (location.country) url += '/' + location.country.replace(new RegExp(' ', 'g'), '-');
            if (location.state) url += '/' + location.state.replace(new RegExp(' ', 'g'), '-');
            if (location.city) url += '/' + location.city.replace(new RegExp(' ', 'g'), '-');
            return url;
        },
        loader: function loader() {
            this.loading = true;
        },
        goBack: function goBack() {

            var goTo = 'lang';
            var type = this.getSearchType();

            switch (type) {
                case 'name':
                    goTo = 'lang';
                    break;
                case 'email':
                    goTo = 'lang-email-search';
                    break;
                case 'phone':
                    goTo = 'lang-phone-search';
                    break;
            }

            this.$router.push({
                name: goTo,
                params: {
                    lang: this.$route.params.lang
                }
            });
        },
        trans: function trans(txt) {
            return this.$root.trans(txt, this.$route.params.lang);
        },
        getCountryByCode: function getCountryByCode(code) {
            return code;
        },
        filter: function filter(id) {
            if (this.selectedLocationFilter == id) {
                $('.person').show();
                this.selectedLocationFilter = '';
                $('#filter_' + id).removeClass('location-filter-active');
            } else {
                $('.person').hide();
                $('.' + id).show();
                this.selectedLocationFilter = id;
                $('.location-filter-active').removeClass('location-filter-active');
                $('#filter_' + id).addClass('location-filter-active');

                $('html, body').animate({ scrollTop: $('.' + id).offset().top }, 'slow');
            }
        },
        nameTrim: function nameTrim(name) {
            var display = '';
            if (this.availableSearchBalance > 0 || this.lastSearchType == 'name') {
                display = name.first ? name.first + ' ' : '';
                display = name.middle ? display + name.middle + ' ' : display;
                display = name.last ? display + name.last : display;
                return display;
            }

            display = name.first ? name.first + ' ' : '';
            display = (name.last ? display + name.last[0] : display) + '...';
            return display;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/_search/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/_search/index.vue
// module chunks = 1